import { Autocomplete, Box, TextField } from "@mui/material";
import { red } from "@mui/material/colors";
import React, { useEffect, useState, useRef } from "react";
import { getSiteLocatioins } from "services/userServices";
import PropTypes from "prop-types";
export default function SiteAutoComplete(props) {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const { onChange, required, setLoading, onLoadValue } = props;
  // Ensures the onLoadValue -> onChange hydration only ever fires once,
  // matching the same fix applied to ClientAutoComplete.
  const hasHydratedRef = useRef(false);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoading(true);
      }

      try {
        const response = await getSiteLocatioins();

        if (cancelled) return;

        if (response.message === "Success") {
          if (!cancelled) {
            setSites(response.data);
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch sites:", error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (hasHydratedRef.current) return;
    if (!onLoadValue || sites.length === 0) return;

    const selectedSite = sites.find((site) => site.SiteLIST === onLoadValue);
    if (selectedSite) {
      setSelectedSite(selectedSite);
      onChange(selectedSite);
      hasHydratedRef.current = true;
    }
  }, [sites, onLoadValue]);

  const handleChange = (event, newValue) => {
    setSelectedSite(newValue);
    onChange(newValue);
  };

  return (
    <Autocomplete
      options={sites}
      value={selectedSite}
      onChange={handleChange}
      getOptionLabel={(option) =>
        option.GeoLocName ? `${option.GeoLocName} (${option.GeoLocCd})` : ""
      }
      sx={{ width: "100%" }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label={
            required ? (
              <Box>
                Site&nbsp;
                <Box component={"span"} sx={{ color: red[700] }}>
                  *
                </Box>
              </Box>
            ) : (
              "Site"
            )
          }
          variant="outlined"
          sx={{ backgroundColor: "#fff" }}
        />
      )}
    />
  );
}
SiteAutoComplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  setLoading: PropTypes.func.isRequired,
  onLoadValue: PropTypes.string,
};
